import { Box } from '@mui/material';
import { CVBuilderFormKeys, HardSkillEntry } from 'utils/cv-form-db';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { RootBox } from '../../components/styledComponents';
import { useCVStepActions } from '../../hooks';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import { DeleteHardSkillModal } from './DeleteHardSkillModal';
import { HardSkillsContent } from './HardSkillsContent';
import { useHardSkillsNavigation } from './useHardSkillsNavigation';

export const HardSkillsStep = () => {
  const { isEditMode } = useEditModeNavigation();

  const {
    isFormOpen,
    isEditing,
    editingItem,
    deleteModalState,
    handleAdd,
    handleEdit,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    handleEditClick,
    handleAddClick,
    handleCancelForm
  } = useCVStepActions<HardSkillEntry>({
    fieldName: CVBuilderFormKeys.HARD_SKILLS,
    disableAutoSave: isEditMode
  });

  const { handleBeforeNavigate } = useHardSkillsNavigation();

  if (isEditMode) {
    return (
      <RootBox
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <HardSkillsContent
          isFormOpen={isFormOpen}
          isEditing={isEditing}
          editingItem={editingItem || null}
          onAdd={handleAdd}
          onEdit={handleEdit}
          onCancel={handleCancelForm}
          onAddClick={handleAddClick}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
        />
        <Box sx={{ flex: 1 }} />
        {!isFormOpen && <EditModeNavigationButtons />}
        <DeleteHardSkillModal
          isOpen={deleteModalState.isOpen}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      </RootBox>
    );
  }

  return (
    <RootBox
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <HardSkillsContent
        isFormOpen={isFormOpen}
        isEditing={isEditing}
        editingItem={editingItem || null}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onCancel={handleCancelForm}
        onAddClick={handleAddClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
      />
      <Box sx={{ flex: 1 }} />
      {!isFormOpen && (
        <>
          <StepNavigationButton
            step="HARD_SKILLS"
            onBeforeNavigate={handleBeforeNavigate}
          />
          <PreviousStepNavigationButton step="HARD_SKILLS" />
        </>
      )}
      <DeleteHardSkillModal
        isOpen={deleteModalState.isOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </RootBox>
  );
};
